export const createUserValidator = (name, value) => {
    switch (name) {
        case 'clientId':
            if (!value) return 'Client is required';
            return '';

        case 'firstname':
            if (!value.trim()) return 'First name is required';
            if (value.length < 2) return 'First name must be at least 2 characters';
            if (value.length > 50) return 'First name must be less than 50 characters';
            return '';

        case 'lastname':
            if (!value.trim()) return 'Last name is required';
            if (value.length < 2) return 'Last name must be at least 2 characters';
            if (value.length > 50) return 'Last name must be less than 50 characters';
            return '';

        case 'email':
            if (!value.trim()) return 'Email is required';
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) return 'Please enter a valid email address';
            return '';

        case 'password':
            if (!value.trim()) return 'Password is required';

            // Password validation rules
            const minLength = 8;
            const hasUpperCase = /[A-Z]/.test(value);
            const hasLowerCase = /[a-z]/.test(value);
            const hasNumbers = /\d/.test(value);
            const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);

            // Validate each rule separately for clear error messages
            if (value.length < minLength) {
                return `Password must be at least ${minLength} characters long`;
            }
            if (!hasUpperCase) {
                return 'Password must contain at least one uppercase letter';
            }
            if (!hasLowerCase) {
                return 'Password must contain at least one lowercase letter';
            }
            if (!hasNumbers) {
                return 'Password must contain at least one number';
            }
            if (!hasSpecialChar) {
                return 'Password must contain at least one special character (!@#$%^&*(),.?":{}|<>)';
            }

            // All rules passed
            return '';
        default:
            return '';
    }
};
